import React from 'react';
import InputWrapper from './InputWrapper';

const CheckBoxInput = ({ field, fieldId, value, onChange, label, isRequired, error }) => {
  return (
    <InputWrapper field={field} label={label} isRequired={isRequired} error={error}>
      <div>
        <input
          type="checkbox"
          checked={value === true || value === 'true'}
          onChange={e => onChange(fieldId, e.target.checked)}
          disabled={field.readOnly || false}
        />
        {field.description && (
          <span className="form-checkbox-description">{field.description}</span>
        )}
      </div>
    </InputWrapper>
  );
};

export default CheckBoxInput;

